import AnimateHeight from 'react-animate-height'

export const AnimatedHeight = ({ children, width, ...props }) => (
  <AnimateHeight {...props} style={{ width: width || '100%' }}>
    {children}
  </AnimateHeight>
)

export default AnimatedHeight
